export const addItemMessage = "Record is successfully created.";
export const editItemMessage = "Record is successfully updated.";
export const deleteItemMessage = "Record is successfully deleted.";
export const successTitle = "Saved!";
